import React from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material'

const ActionTimeoutDialog = ({
  open,
  anearEvent,
  prompt,
  resetLabel,
  exitLabel,
  onReset,
  onExit,
}) => {
  const iconUrl = anearEvent?.zone?.app?.iconUrl
  const shortName = anearEvent?.zone?.app?.shortName

  return (
    <Dialog
      open={open}
      onClose={() => onReset?.()}
      aria-labelledby="action-timeout-title"
      maxWidth="xs"
      fullWidth
    >
      <DialogContent>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {iconUrl && (
            <img
              style={{
                height: '90px',
                float: 'left',
                marginRight: '16px',
              }}
              src={iconUrl}
              alt={shortName || 'Event'}
            />
          )}
          <Typography id="action-timeout-title" variant="h6">
            {prompt || 'Do you still want to participate?'}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        {exitLabel ? (
          <Button onClick={onExit} color="primary" variant="outlined">
            {exitLabel}
          </Button>
        ) : null}
        <Button
          onClick={onReset}
          color="primary"
          variant={exitLabel ? 'contained' : 'contained'}
        >
          {resetLabel || 'Yes'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ActionTimeoutDialog

